import { date } from 'quasar'

export class DateNameFormatter {
  constructor () {
    this.today = new Date().toDateString()

    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    this.yesterday = yesterday.toDateString()

    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.tomorrow = tomorrow.toDateString()
  }

  getDateName (millis, useNumberFormat) {
    const dateFormatted = date.formatDate(millis, 'DD.MM')
    if (!useNumberFormat) {
      let alias
      const dateString = new Date(millis).toDateString()
      if (this.today === dateString) {
        alias = 'Сегодня'
      } else if (this.yesterday === dateString) {
        alias = 'Вчера'
      } else if (this.tomorrow === dateString) {
        alias = 'Завтра'
      }

      if (alias) {
        return dateFormatted + ' - ' + alias
      }
    }
    return dateFormatted
  }
}

export const vehicleProvisionSummaryMixin = {
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      title: 'Сводка по суточным автовышкам (текущие значения)'
    }
  },
  methods: {
    getBaseColumns: function () {
      return [{
        name: 'notCanceled',
        label: 'Число заявок',
        labelTable: 'Число<br>заявок',
        align: 'right',
        field: 'notCanceled',
        sortable: false
      }, {
        name: 'reserved',
        label: 'Резерв',
        align: 'right',
        field: 'reserved',
        sortable: false
      }, {
        name: 'ordered',
        label: 'Заказано',
        labelTable: 'Заказано<br>всего',
        align: 'right',
        field: 'ordered',
        sortable: false
      }, {
        name: 'notProvided',
        label: 'Не предоставлено',
        labelTable: 'Не предо-<br>ставлено',
        align: 'right',
        field: 'notProvided',
        sortable: false
      }, {
        name: 'active',
        label: 'В наличии',
        labelTable: 'В наличии<br>всего',
        align: 'right',
        field: 'active',
        sortable: false
      }, {
        name: 'inWork',
        label: 'В работе',
        align: 'right',
        field: 'inWork',
        sortable: false
      }, {
        name: 'notUsed',
        label: 'Не используется',
        align: 'right',
        field: 'notUsed',
        sortable: false
      }, {
        name: 'unusable',
        label: 'Непригодно',
        align: 'right',
        field: 'unusable',
        sortable: false
      }]
    },
    getIntervalName: function (interval, dateNameFormatter, useNumberFormat) {
      if (!dateNameFormatter) {
        dateNameFormatter = new DateNameFormatter()
      }

      let intervalName = dateNameFormatter.getDateName(interval.startTime, useNumberFormat)
      if (interval.type == 'day') {
        intervalName += ' (день)'
      } else {
        intervalName += ' (ночь)'
      }
      return intervalName
    },
    getIntervalStyle: function (interval, light) {
      const day = interval.type === 'day'
      const color = day && 'black' || 'white'
      const bgColor = day && '#ceffce' || (light ? '#c7c7c7' : '#666666')
      return this.getCellStyle(bgColor, color)
    },
    getCellStyle: function (bgColor, color) {
      return `background-color: ${bgColor} !important;
          color: ${color} !important;`
    }
  }
}
